/**
* this displays the fund overview
*
* Created by Paul on 27/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import moment from 'moment'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'
import config from '../../config'
import { isEmpty } from '../../utility/utilities'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles';
import { createMuiTheme } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
    },
    card: {
        height: '100%',
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
})

class FundOverview extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {

        const { getFundData, member_id } = this.props

        getFundData(member_id)
    }

    renderPrimaryContact() {
        
        const { classes, fundInfoData, membersTrusteesInfoData, isLoading } = this.props

        return (

            <Card className={classes.card}>
                <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                        Primary Contact
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                        Account Holder
                    </Typography>

                    <Typography className={classes.card_body}>
                        { this.getFullName(membersTrusteesInfoData[0].data) }
                        <br />
                        { membersTrusteesInfoData[0].data.phone ? this.getPhoneNumber(membersTrusteesInfoData[0].data.phone) : "Phone number not provided" }
                        <br />
                        { membersTrusteesInfoData[0].data.email ? <a href={ 'mailto:' + membersTrusteesInfoData[0].data.email }>{ membersTrusteesInfoData[0].data.email }</a> : "Email not provided" }
                    </Typography>
                </CardContent>
            </Card>

        )
    }

    renderFundStructure() {

        const { classes, fundInfoData, membersTrusteesInfoData, companyDetailsData } = this.props
        let fund_type = fundInfoData.fund_type.charAt(0).toUpperCase() + fundInfoData.fund_type.toLowerCase().slice(1)

        return (

            <Card className={classes.card}>
                <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      Fund Structure
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Basic Structure Details
                    </Typography>

                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Fund Name:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { fundInfoData.fund_name }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Type:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { fund_type }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    TFN:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { fundInfoData.tfn }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    ABN:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { fundInfoData.abn }
                                </Typography>
                            </Grid>
                        </Grid>
                        { fundInfoData.fund_type === 'CORPORATE' &&
                            <Grid container>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        Company Name:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { companyDetailsData.company_name }
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography className={classes.card_body}>
                                        ACN:
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography className={classes.card_body}>
                                        { companyDetailsData.acn ? companyDetailsData.acn : '-' }
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Jurisdiction:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    { fundInfoData.jurisdiction }
                                </Typography>
                            </Grid>
                        </Grid>

                </CardContent>
            </Card>

        )
    }

    renderFundOverview() {

        const { classes, member_id, isFundPositionLoading, fundPosition, fundAssetSummary } = this.props

        let fundValue = isFundPositionLoading ? 'Loading ...' : <NumberFormat value={ fundPosition } displayType={'text'} thousandSeparator={true} prefix={'$'} />
        
        const assetAllocationURL = config.endpoints.investmentDownloadURL + member_id + '/' + moment().format("YYYY-MM-DD")

        return (
            <Card className={classes.card}>
                <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                        Fund Overview
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                        Fund Position and Asset Breakdown
                    </Typography>

                    <Grid container>
                        <Grid item xs={4}>
                            <Typography className={classes.card_body}>
                                Portfolio Value:
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography className={classes.card_body}>
                                { fundValue }
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container>
                    { isFundPositionLoading ? (
                        <React.Fragment>
                            <Grid item xs={4}>
                                <Typography className={classes.card_body}>
                                    Asset Summery:
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography className={classes.card_body}>
                                    Loading ...
                                </Typography>
                            </Grid>
                        </React.Fragment>
                    ):(
                        
                        fundAssetSummary.map((item,index) => {
                            return (
                                <React.Fragment key={ index }>
                                    <Grid item xs={4}>
                                        <Typography className={classes.card_body}>
                                            { index === 0 && <span>Asset Summery:</span> }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography className={classes.card_body}>
                                            { item['asset_class_name'] } - { item['asset_strategy_overall_percent'] }%
                                        </Typography>
                                    </Grid>
                                </React.Fragment>
                            )
                        })
                    )}

                    </Grid>

                </CardContent>
                
                <CardActions>
                    <Button size="small" href={ assetAllocationURL } target="_blank">Download Report</Button>
                </CardActions>
            </Card>
     
        )
    }

    getFullName(member) {
        let name = member.title.charAt(0).toUpperCase() + member.title.slice(1).toLowerCase() + ' ' + member.first_name

        if (!isEmpty(member.middle_name)) {
            name += ' ' + member.middle_name
        }

        return name + ' ' + member.last_name
    }

    getPhoneNumber(number) {
        return number.substring(0, 4) + ' ' + number.substring(4, 7) + ' ' + number.substring(7, 10)
    }

    render() {

        const { classes, isLoading } = this.props
        
        return (
            
            <ExpansionPanelDetails>

                { isLoading ? ( 
                    <Typography>Loading ...</Typography>
                ) : (
                    <div className={classes.gridroot}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                { this.renderPrimaryContact() }
                            </Grid>
                            <Grid item xs={12} md={4}>
                                { this.renderFundStructure() }
                            </Grid>
                            <Grid item xs={12} md={4}>
                                { this.renderFundOverview() }
                            </Grid>
                        </Grid>
                    </div>
                )}

            </ExpansionPanelDetails>


            /*
            <ExpansionPanelDetails>

                { isLoading && 
                    <Typography>Loading ...</Typography>
                }
                
                { isLoading === false &&
                    <div className={classes.gridroot}>
                        <Grid container spacing={3}>

                            <Grid item xs={12} md={4}>
                                { this.renderPrimaryContact() }
                            </Grid>

                            <Grid item xs={12} md={4}>
                                { this.renderFundStructure() }
                            </Grid>

                            <Grid item xs={12} md={4}>
                                { this.renderFundOverview() }
                            </Grid>

                        </Grid>
                    </div>
                }
                        
            </ExpansionPanelDetails>

            */
        )
    }
}

// define the prop types
FundOverview.propTypes = {
    classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    fundInfoData: PropTypes.object,
    membersTrusteesInfoData: PropTypes.array,
    companyDetailsData: PropTypes.object,
    isFundPositionLoading: PropTypes.bool,
    fundPosition: PropTypes.number,
    fundAssetSummary: PropTypes.array,
}

const mapStateToPros = (state) => {
    return {
        isLoading: state.fundState.isLoading,
        membersTrusteesInfoData: state.fundState.membersTrusteesInfoData,
        fundInfoData: state.fundState.fundInfoData,
        companyDetailsData: state.fundState.companyDetailsData,
        isFundPositionLoading: state.fundState.isFundPositionLoading,
        fundPosition: state.fundState.fundPosition,
        fundAssetSummary: state.fundState.fundAssetSummary,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundData: action.getFundData
    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(FundOverview))


// WEBPACK FOOTER //
// ./src/components/FundOverview/index.js